import React from 'react';

const PrintFormatSelector = ({ isOpen, onClose, onSelectFormat, formats = 'default', hasItemReceipts = false }) => {
  if (!isOpen) return null;

  // Default formats for Order/Booking/Selection modules
  const defaultFormats = (
    <>
      <button
        onClick={() => onSelectFormat('a4')}
        className="w-full p-4 sm:p-6 border-2 border-gray-200 rounded-xl hover:border-amber-500 hover:bg-amber-50 transition-all text-left group"
      >
        <div className="flex items-center gap-3 sm:gap-4">
          <div className="text-3xl sm:text-4xl">📄</div>
          <div className="flex-1">
            <h3 className="text-base sm:text-xl font-bold text-gray-800 group-hover:text-amber-700">
              A4 Full Detail Print
            </h3>
          </div>
        </div>
      </button>

      <button
        onClick={() => onSelectFormat('thermal')}
        className="w-full p-4 sm:p-6 border-2 border-gray-200 rounded-xl hover:border-amber-500 hover:bg-amber-50 transition-all text-left group"
      >
        <div className="flex items-center gap-3 sm:gap-4">
          <div className="text-3xl sm:text-4xl">🧾</div>
          <div className="flex-1">
            <h3 className="text-base sm:text-xl font-bold text-gray-800 group-hover:text-amber-700">
              3" Thermal - Detailed
            </h3>
          </div>
        </div>
      </button>

      <button
        onClick={() => onSelectFormat('thermal-summary')}
        className="w-full p-4 sm:p-6 border-2 border-gray-200 rounded-xl hover:border-amber-500 hover:bg-amber-50 transition-all text-left group"
      >
        <div className="flex items-center gap-3 sm:gap-4">
          <div className="text-3xl sm:text-4xl">📝</div>
          <div className="flex-1">
            <h3 className="text-base sm:text-xl font-bold text-gray-800 group-hover:text-amber-700">
              3" Thermal - Summary
            </h3>
          </div>
        </div>
      </button>

      {hasItemReceipts && (
        <button
          onClick={() => onSelectFormat('item-receipts')}
          className="w-full p-4 sm:p-6 border-2 border-amber-300 bg-amber-50 rounded-xl hover:border-amber-500 hover:bg-amber-100 transition-all text-left group"
        >
          <div className="flex items-center gap-3 sm:gap-4">
            <div className="text-3xl sm:text-4xl">🏷️</div>
            <div className="flex-1">
              <h3 className="text-base sm:text-xl font-bold text-gray-800 group-hover:text-amber-700">
                Print Item Receipts
              </h3>
              <p className="text-xs sm:text-sm text-gray-600 mt-1">Old Gold & Metal Credit individual receipts</p>
            </div>
          </div>
        </button>
      )}
    </>
  );

  // Approval formats
  const approvalFormats = (
    <>
      <button
        onClick={() => onSelectFormat('customer')}
        className="w-full p-4 sm:p-6 border-2 border-gray-200 rounded-xl hover:border-amber-500 hover:bg-amber-50 transition-all text-left group"
      >
        <div className="flex items-center gap-3 sm:gap-4">
          <div className="text-3xl sm:text-4xl">📄</div>
          <div className="flex-1">
            <h3 className="text-base sm:text-xl font-bold text-gray-800 group-hover:text-amber-700">
              Customer Print (A4)
            </h3>
            <p className="text-xs sm:text-sm text-gray-600 mt-1">Clean format without internal remarks</p>
          </div>
        </div>
      </button>

      <button
        onClick={() => onSelectFormat('internal')}
        className="w-full p-4 sm:p-6 border-2 border-gray-200 rounded-xl hover:border-amber-500 hover:bg-amber-50 transition-all text-left group"
      >
        <div className="flex items-center gap-3 sm:gap-4">
          <div className="text-3xl sm:text-4xl">📋</div>
          <div className="flex-1">
            <h3 className="text-base sm:text-xl font-bold text-gray-800 group-hover:text-amber-700">
              Internal Print (A4)
            </h3>
            <p className="text-xs sm:text-sm text-gray-600 mt-1">Complete record with all internal details</p>
          </div>
        </div>
      </button>

      <button
        onClick={() => onSelectFormat('thermal-customer')}
        className="w-full p-4 sm:p-6 border-2 border-gray-200 rounded-xl hover:border-amber-500 hover:bg-amber-50 transition-all text-left group"
      >
        <div className="flex items-center gap-3 sm:gap-4">
          <div className="text-3xl sm:text-4xl">🧾</div>
          <div className="flex-1">
            <h3 className="text-base sm:text-xl font-bold text-gray-800 group-hover:text-amber-700">
              Customer Print (3" Thermal)
            </h3>
            <p className="text-xs sm:text-sm text-gray-600 mt-1">Customer copy for thermal printer</p>
          </div>
        </div>
      </button>

      <button
        onClick={() => onSelectFormat('thermal-internal')}
        className="w-full p-4 sm:p-6 border-2 border-gray-200 rounded-xl hover:border-amber-500 hover:bg-amber-50 transition-all text-left group"
      >
        <div className="flex items-center gap-3 sm:gap-4">
          <div className="text-3xl sm:text-4xl">📝</div>
          <div className="flex-1">
            <h3 className="text-base sm:text-xl font-bold text-gray-800 group-hover:text-amber-700">
              Internal Print (3" Thermal)
            </h3>
            <p className="text-xs sm:text-sm text-gray-600 mt-1">Internal copy with all details for thermal printer</p>
          </div>
        </div>
      </button>

      {hasItemReceipts && (
        <button
          onClick={() => onSelectFormat('item-receipts')}
          className="w-full p-4 sm:p-6 border-2 border-amber-300 bg-amber-50 rounded-xl hover:border-amber-500 hover:bg-amber-100 transition-all text-left group"
        >
          <div className="flex items-center gap-3 sm:gap-4">
            <div className="text-3xl sm:text-4xl">🏷️</div>
            <div className="flex-1">
              <h3 className="text-base sm:text-xl font-bold text-gray-800 group-hover:text-amber-700">
                Print Item Receipts
              </h3>
              <p className="text-xs sm:text-sm text-gray-600 mt-1">Old Gold & Metal Credit individual receipts</p>
            </div>
          </div>
        </button>
      )}
    </>
  );

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div 
        className="bg-white rounded-xl p-4 sm:p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl" 
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 text-gray-800 text-center">Select Print Format</h2>
        
        <div className="space-y-3 sm:space-y-4">
          {formats === 'approval' ? approvalFormats : defaultFormats}
        </div>

        <div className="mt-4 sm:mt-6 text-center">
          <button
            onClick={onClose}
            className="px-6 py-2 text-gray-600 hover:text-gray-800 font-medium"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrintFormatSelector;
